import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpService } from '../../../services/http/http.service';

@Component({
  selector: 'app-edit-topic',
  templateUrl: './edit-topic.component.html',
  styleUrls: ['./edit-topic.component.scss']
})
export class EditTopicComponent implements OnInit {
  topicTypeArr = ['Easy', 'Medium', 'Hard'];
  pointsArr = ['1', '2', '3', '4'];
  topicName = new FormControl('', [Validators.required]);
  topicType = new FormControl('', [Validators.required]);
  topic;
  // dataArray: any = [];
  constructor(
   public snackbar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService,
    private httpService: HttpService,
    public dialogRef: MatDialogRef<EditTopicComponent>,

    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.topic = data;
   }

  ngOnInit() {
    console.log("topic", this.topic);
  }

  closeDialog(flag: boolean): void {
    this.dialogRef.close(flag);
  }
  getTopicNameErrorMessage() {
    return this.topicName.hasError('required') ? 'Topic Name is required' :
      '';
  }

  openSnackBar(message: string) {
    this.snackbar.open(message, null, {
      duration: 2000,
    });
  }
}
